import { FunctionComponent } from "react";

import Icon from "../Icon";
import { Icons } from "../@types/icons";
import NoData from "../NoData";
import Typography from "../typography/Typography";

const STATUS_CLASS_TEXT: Record<number, string> = {
  1: "INFO",
  2: "OK",
  3: "REDIRECT",
  4: "CLIENT ERROR",
  5: "SERVER ERROR"
};

const getHttpStatusText = (code?: number): string | null =>
  code != null ? STATUS_CLASS_TEXT[Math.floor(code / 100)] ?? null : null;

type IconConfig = { name: Icons; className: string };

const getStatusIcon = (code?: number): IconConfig | null => {
  if (code == null) return null;
  const cls = Math.floor(code / 100);
  switch (cls) {
    case 1:
      return { name: "error-i", className: "text-info" };
    case 2:
      return { name: "checkmark", className: "text-success" };
    case 3:
      return { name: "warning-circle", className: "text-warning" };
    case 4:
    case 5:
      return { name: "error", className: "text-danger" };
    default:
      return null;
  }
};

type ResponseCodeBadgeProps = {
  code?: number;
};

const ResponseCodeBadge: FunctionComponent<ResponseCodeBadgeProps> = ({
  code
}) => {
  const icon = getStatusIcon(code);
  const statusText = getHttpStatusText(code);

  return (
    <span className="d-inline-flex align-items-center">
      <Typography variant="body3" tag="span">
        HTTP Status:&nbsp;
      </Typography>
      {icon && (
        <Icon
          name={icon.name}
          size={14}
          className={`${icon.className}`}
          style={{ marginRight: 3 }}
        />
      )}
      <Typography variant="body4" tag="span">
        {code != null ? (
          <>
            {code}
            {statusText ? ` (${statusText})` : ""}
          </>
        ) : (
          <NoData />
        )}
      </Typography>
    </span>
  );
};

export default ResponseCodeBadge;
